import { Link } from "react-router-dom";
import type { EntitySummary } from "../../shared/api";
import { Stars } from "./Stars";
import { Logo } from "./States";
import { ClaimBadge } from "./Badge";
import { fmtRating } from "../lib/format";
import { useCompare } from "../lib/compareStore";

export function EntityCard({ e }: { e: EntitySummary }) {
  const cmp = useCompare();
  const selected = cmp.has(e.id);

  // The card is a container rather than one big anchor: the compare control is a
  // button, and a button inside an anchor is invalid markup that also swallows
  // the click into a navigation.
  return (
    <div className="card entity-card">
      <Link to={`/${e.type}/${e.slug}`} className="entity-card-main">
        <div className="top">
          <Logo url={e.logoUrl} name={e.name} />
          <div className="u-5f678f8">
            <div className="row u-4173603">
              <h3>{e.name}</h3>
              {e.symbol && <span className="muted mono u-c956592">{e.symbol}</span>}
            </div>
            <p className="desc">{e.shortDesc}</p>
          </div>
        </div>
      </Link>
      <div className="foot">
        <span className="row u-32eb258">
          <Stars value={e.ratingWeighted} />
          <span className="rating-num u-eed0f8f">{fmtRating(e.ratingWeighted)}</span>
          <span className="muted u-474a305">({e.reviewCount})</span>
        </span>
        <span className="row gap-8">
          <ClaimBadge status={e.claimStatus} />
          <button
            className={`btn btn-sm ${selected ? "btn-primary" : "btn-ghost"}`}
            aria-pressed={selected}
            disabled={!selected && cmp.full}
            onClick={() => cmp.toggle(e.id)}
            title={!selected && cmp.full ? "You can compare up to four at once" : undefined}
          >
            {selected ? "Selected" : "Compare"}
          </button>
        </span>
      </div>
    </div>
  );
}
